import { render, staticRenderFns } from "./ClinicProfileComponent.vue?vue&type=template&id=37f38b94&scoped=true"
import script from "./ClinicProfileComponent.vue?vue&type=script&lang=js"
export * from "./ClinicProfileComponent.vue?vue&type=script&lang=js"
import style0 from "./ClinicProfileComponent.vue?vue&type=style&index=0&id=37f38b94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f38b94",
  null
  
)

export default component.exports